import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import answerSearchResource from 'src/actions/answers/answerSearchResource';
import searchDropdownResource, { AnswerSearchQueryFilter } from 'src/actions/searchDropdown/searchDropdownResource';

export enum AnswerType {
  PUBLIC = 'SELF_SERVICE',
  EMAIL = 'ANY_CHANNEL',
  MESSAGE = 'MESSAGE',
}

const getSearchParams = (answerType: AnswerType, language: string): AnswerSearchQueryFilter => ({
  hasFields: [
    { language, name: 'CONTENTS' },
    { language, name: answerType },
  ],
});

const useAnswersFilter = ({
  answerType,
  audienceId,
  fieldName,
  language,
}: {
  answerType: AnswerType;
  fieldName?: string;
  language: string;
  audienceId: string;
}) => {
  const { request: searchForAnswer } = fieldName ? searchDropdownResource.effects : answerSearchResource.effects;
  const dispatch = useDispatch();

  return useCallback(
    (text: string) => {
      const filter: AnswerSearchQueryFilter = getSearchParams(answerType, language);

      if (audienceId) {
        filter.audienceIds = [audienceId];
      }
      dispatch(searchForAnswer({ fieldName, filter, language, text }));
    },
    [answerType, audienceId, dispatch, fieldName, searchForAnswer, language]
  );
};

export default useAnswersFilter;
